import SerializableObject from '@/utils/models/serializableobject.model';
import { KioskBranchData } from '../kiosk/kiosk.model';

export default class KioskBranchResponse extends SerializableObject {
  KioskBranchData?: KioskBranchData;
}
